import React, { useState, useEffect } from 'react'
import './Label.css'

function Label({ 
  simple = false, 
  labelColor = "gray", 
  bright = false, 
  title = "no title", 
  fontSize = "0.75rem",
  onClick = () => {},
  maxWidth = "100%",
  minWidth = "auto"
}) {

  return (
    <div className={`label ${simple ? "" : labelColor} ${bright ? "bright" : null}`} style={{ maxWidth: maxWidth, minWidth: minWidth }}>
      <div className={`ball ${labelColor} ${bright ? "bright" : null}`}></div>
      <h4 style={simple ? { fontWeight: "300", fontSize: fontSize } : null}>{title}</h4>
    </div>
  )
}

export default Label